/* eslint-disable camelcase */
import { DaoModel } from './daoModel';
import { ModelLanguage } from './modelLanguage';
import { FrontGroup } from './frontGroup';
import { Currency } from './currency';

export class PointOfSale extends DaoModel {
  constructor(guid, name, isManaged, logo, id, useSaleFormats, availableFrontRoutes, languageAlt1, languageAlt2, languageAlt3, clientLogo, currency) {
    super(guid);
    this.id = id || null;
    this.name = name || '-1';
    this.isManaged = isManaged || false;
    this.logo = logo || null;
    this.useSaleFormats = useSaleFormats || false;
    this.availableFrontGroups = availableFrontRoutes;
    this.languageAlt1 = ModelLanguage.toInstance(languageAlt1);
    this.languageAlt2 = languageAlt2 ? ModelLanguage.toInstance(languageAlt2) : null;
    this.languageAlt3 = languageAlt3 ? ModelLanguage.toInstance(languageAlt3) : null;
    this.clientLogo = clientLogo;
    this.currency = Currency.toInstance(currency);
  }

  static toInstance(props = {}) {
    const availableFrontGroups = FrontGroup.toInstanceList(props.available_front_groups);
    return new PointOfSale(props.guid, props.name, props.is_managed, props.logo, props.id,
      props.use_sale_formats, availableFrontGroups, props.language_alt1, props.language_alt2,
      props.language_alt3, props.client_logo, props.currency);
  }

  serialize() {
    return {
      ...super.serialize(),
      name: this.name,
      is_managed: this.isManaged,
      logo: this.logo,
      id: this.id,
      use_sale_formats: this.useSaleFormats,
      available_front_groups: this.availableFrontRoutes,
      language_alt1: this.languageAlt1,
      language_alt2: this.languageAlt2,
      language_alt3: this.languageAlt3,
      currency: this.currency,
    };
  }
}
